import { Icon, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

export type Platform = "web" | "mobile";

const platformConfig: Record<Platform, { icon: string; label: string }> = {
  web: { icon: "Global", label: "Web App" },
  mobile: { icon: "Mobile", label: "Mobile App" },
};

export interface PlatformPillProps {
  platform: Platform;
  className?: string;
}

/**
 * Tells the operator where a Get Started step happens — in this web portal or in the Driver App.
 * The generic `Badge` atom has no outlined variant and no icon slot, hence a dedicated pill.
 */
export const PlatformPill = ({ platform, className }: PlatformPillProps) => {
  const { icon, label } = platformConfig[platform];

  return (
    <div
      className={clsx(
        "inline-flex items-center gap-0.5 whitespace-nowrap rounded-full border border-vivid-purple bg-vivid-purple/10 px-2 py-1",
        className
      )}
      data-testid={`platform-pill-${platform}`}
    >
      <Icon name={icon} size={16} className="shrink-0 text-vivid-purple-dark" />
      <Typography variant="small" className="!leading-4 text-vivid-purple-dark">
        {label}
      </Typography>
    </div>
  );
};
